module.exports = __webpack_public_path__ + "img/quizz-step-3-2.665809e9.jpg";